import { render } from "./HomeView.vue?vue&type=template&id=063c137a"
const script = {}

import exportComponent from "/dev/shm/repo/dpgui-e3xyqnybj2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__